'use strict';

// Turn jsonlint-lines-primitives objects into primitive objects
module.exports = function unbundle(value) {
    if (value instanceof Number || value instanceof String || value instanceof Boolean) {
        return value.valueOf();
    } else {
        return value;
    }
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/mapbox-gl-style-spec/lib/util/unbundle_jsonlint.js
 ** module id = 107
 ** module chunks = 0
 **/